<template>
  <div class="content_con">
    <p class="text-center">
      <span class="title">东进公司2025年度PCO 管理顾问咨询项目</span>
    </p>
    <p class="text-center subtitle-container">
      <span class="title">成交结果公告</span>
    </p>
    <p class="text-indent-37 line-height-37 item">
      <span class="text"><span>本公司(广东东进有害生物防控技术有限公司)于2025年3月14日 就东进公司2025年度PCO
          管理顾问咨询项目进行了公开遴选采购。现就本次采购的中标、成交结果公告如下：</span></span>
    </p>
    <p class="line-height-40 section-title">
      <span class="text">一、采购项目名称：东进公司2025年度PCO 管理顾问咨询项目</span>
    </p>
    <p class="line-height-40 section-title">
      <span class="text">二 、采购方式：公开遴选采购</span>
    </p>
    <p class="line-height-40 section-title">
      <span class="text">三、中标、成交供应商名称：广东毅翔达环境科技有限公司，
        成交单价如下图所示：</span>
    </p>

    <el-table
      :data="workTableData"
      style="width: 100%;"
      border
    >
      <el-table-column
        prop="index"
        label="序号"
        width="50"
        header-align="center"
      />
      <el-table-column
        prop="workContent"
        label="工作内容"
        header-align="center"
      />
      <el-table-column
        prop="unit"
        label="单位"
        width="100"
        header-align="center"
      />
      <el-table-column
        prop="price"
        label="单价（元）"
        width="100"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        header-align="center"
      />
      <template slot="append">
        <div style="padding:10px 20px;color:#000;font-weight:700;">
          备注：以上项目根据管理方需求安排或中标方审批计划执行，具体以实际开展项目进行结算，单价金额已含增值税专用发票__3__%，每季度结算一次。
        </div>
      </template>
    </el-table>

    <p class="line-height-40 section-title">
      <span class="section-title-text">四、评审日期：2025年3月14日</span>
    </p>
    <p class="text-indent-37 line-height-37 item">
      <span class="text">评审地点: 广东东进有害生物防控技术有限公司214会议室</span>
    </p>
    <p class="text-indent-37 line-height-37 item">
      <span class="text">评审过程：经评审小组评审，<span style="text-decoration: underline;">
          广东毅翔达环境科技有限公司 </span>被推荐为 成交候选人。</span>
    </p>

    <p class="line-height-40 section-title">
      <span class="section-title-text">五、本公告期限1个工作日</span>
    </p>
    <p class="line-height-40 section-title">
      <span class="section-title-text">六、联系事项</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span>单位名称：广东东进有害生物防控技术有限公司</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span class="text">联系人：张雪婷</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span class="text">联系电话：</span>
      <span class="number">18038371084</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span class="text">邮箱地址：</span>
      <span class="number">3403006320@qq.com</span>
    </p>
    <p class="signature">
      <span class="content">发布人：广东东进有害生物防控技术有限公司</span>
    </p>
    <p class="signature">
      <span class="content">发布时间：</span>
      <span class="number">2025</span>
      <span class="content">年</span>
      <span class="number">3</span>
      <span class="content">月</span>
      <span class="number">17</span>
      <span class="content">日</span>
    </p>
    <p style="height:20px"></p>
    <p style="line-height: 16px;"><a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
        title=""
      ><img
          style="vertical-align: middle; margin-right: 2px;"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
        ></a><a
        style="font-size:12px; color:#0066cc;"
        href="/20250324/成交结果公告-东进公司2025年度PCO 管理顾问咨询项目 成交结果公告.pdf"
        title="成交结果公告-东进公司2025年度PCO 管理顾问咨询项目 成交结果公告.pdf"
      >成交结果公告-东进公司2025年度PCO 管理顾问咨询项目 成交结果公告.pdf</a></p>
  </div>
</template>

<script>
export default {
  name: 'DocDisplay',
  data () {
    return {
      ahref: '',
      workTableData: [
        { index: 1, workContent: '一线员工技能/专业素质提升培训', unit: '人/次', price: '5000', remark: '' },
        { index: 2, workContent: '广东省内范围管理人员学习交流', unit: '人/次', price: '1500', remark: '' },
        { index: 3, workContent: '组织参加国家级行业协会交流活动', unit: '人/次', price: '6000', remark: '' },
        { index: 4, workContent: '组织参加广东省行业协会交流活动', unit: '人/次', price: '4000', remark: '' },
        { index: 5, workContent: '组织参加东莞市行业协会交流活动', unit: '人/次', price: '2000', remark: '' },
        { index: 6, workContent: '委派行业专家对卫健/爱卫系统、林业系统、农业系统、水利系统、教育系统、交通运输系统专题讲座。', unit: '人/次', price: '10000', remark: '' },
        { index: 8, workContent: '卫健/爱卫系统、林业系统、农业系统、水利系统、教育系统、交通运输系统项目技术培训指导。', unit: '人/次', price: '5000', remark: '' },
        { index: 10, workContent: '商业客户项目现场技术指导', unit: '人/次', price: '3000', remark: '' },
        { index: 11, workContent: '重点客户培训/相关单位讲座', unit: '人/次', price: '5000', remark: '' },
        { index: 12, workContent: '信息化管理支持', unit: '人/日', price: '2500', remark: '' },
        { index: 13, workContent: '招投标专题辅导/线上咨询支持', unit: '人/次', price: '2000', remark: '' },
        { index: 14, workContent: '相关职业资格培训证书申报（初级）', unit: '人', price: '3000', remark: '' },
        { index: 15, workContent: '相关职业资格培训证书申报（中级）', unit: '人', price: '4000', remark: '' },
        { index: 16, workContent: '相关职业资格培训证书申报（高级）', unit: '人', price: '6000', remark: '' },
        { index: 17, workContent: '相关职业资格培训证书申报（二级技师）', unit: '人', price: '8000', remark: '' },
        { index: 18, workContent: '相关职业资格培训证书申报（一级技师）', unit: '人', price: '10000', remark: '' },
        { index: 19, workContent: '市场调研报告/可行性报告/资质辅导资料', unit: '次', price: '3000', remark: '' },
        { index: 20, workContent: '市级企业消杀、清洁行业资质辅导', unit: '次', price: '12000', remark: '' },
        { index: 21, workContent: '省级企业消杀、林业行业资质辅导', unit: '次', price: '25000', remark: '' },
        { index: 22, workContent: '国家级企业消杀行业资质辅导', unit: '次', price: '40000', remark: '' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.content_con {
  font-size: 14px;
  font-family: "宋体", Arial;
  padding: 0px 50px;
  color: #515050;

  a {
    text-decoration: none;
  }

  .text-center {
    text-align: center;
  }

  .subtitle-container {
    margin-bottom: 21px;
  }

  .line-height-2em {
    line-height: 2em;
  }

  .text-indent-37 {
    text-indent: 37px;
  }

  .line-height-37 {
    line-height: 37px;
  }

  .section-title {
    font-size: 19px;
    font-family: 黑体;
  }

  .item {
    font-size: 19px;
    font-family: 仿宋_GB2312;
  }

  .number {
    font-family: "Times New Roman", "serif";
  }

  .underline {
    text-decoration: underline;
  }

  .title {
    font-size: 27px;
    font-family: 方正小标宋简体;
  }

  .subtitle {
    font-size: 27px;
    font-family: 方正小标宋简体;
  }

  .text-autospace {
    margin: 3px;
    padding: 3px;

    span {
      color: #515050;
      font-size: 14px !important;
    }
  }

  .icon {
    margin-left: 5px;
    vertical-align: middle;
  }

  .file-link {
    text-align: left;
    font-size: 12px;
    color: #0066cc;
  }

  .line-height-40 {
    line-height: 40px;
  }

  .date {
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: "Times New Roman", "serif";
    font-weight: normal;
  }

  .result {
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: 仿宋_GB2312;
    font-weight: 200;
    font-size: 19px;

    .fa {
      font-size: 19px;
      font-family: "Times New Roman", "serif";
      font-weight: normal;
    }
  }

  .duration {
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: 仿宋_GB2312;
    font-weight: normal;
  }

  .signature {
    font-size: 19px;
    line-height: 39px;
    font-family: 仿宋_GB2312;
    text-align: right;
  }
}
</style>
